import React from "react";
import { Link } from "react-router-dom";

const Login = (props) => {
  const { openMod, modOpen, setMod, closeMod } = props;
  function logind() {
    alert("No Account Found. Kindly Book a Demo");
  }
  return (
    <section>
      <div className="form-container">
        <div className="form-content">
          <div className="form-text">
            <h1>Welcome back!</h1>
            <h2 style={{ textAlign: "center" }}>
              Let’s get you back to automating your workflow.
            </h2>
          </div>
          <form className="form">
            <div className="input-container">
              <div className="input-Pad">
                <img src="email.svg" alt="" />
                <input type="email" placeholder="Email address" name="" id="" />
              </div>
            </div>
            <div className="input-container">
              <div className="input-Pad">
                <img src="password.svg" alt="" />
                <input
                  type="password"
                  placeholder="Password"
                  name=""
                  id=""
                  minLength={6}
                />
              </div>
            </div>
            {/* <Link to="/reset-password">
              <h6 className="text-lile">Forgot Password?</h6>
            </Link> */}
            <button className="submit" onClick={logind}>
              Continue
            </button>
          </form>
          <h6 className="tabtext" style={{ marginTop: "10px" }}>
            Don't have an account?{" "}
            <button onClick={openMod} style={{ color: "#624de3" }}>
              Book a Demo
            </button>
          </h6>
        </div>
      </div>
    </section>
  );
};

export default Login;
